export default __webpack_public_path__ + "static/media/quinbite.6d8b15dc.png";